import { DELETE_AVATAR } from '@components/App/SystemDialogs/constants'

import { PLAN_FREE, PLAN_MONTHLY } from '@/constants/userSubscriptionPlans'
import { LAST_WORKSPACE_KEY } from '@/store/reducers/dashboard/constants'
import * as ActionTypes from '../actions'
import { openSystemDialog } from './ui'

const initialState = {
  authenticated: false,
  advanced: false,
  planId: PLAN_FREE,
  planType: PLAN_MONTHLY,
  projects: [],
  projectsCount: 0,
  projectsLimit: 0,
  redeemed: false,
  teams: [],
  messages: [],
}

const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.CHANGE_PROJECT_NAME:
      return {
        ...state,
        projects: state.projects.map((project) => {
          if (project.id === payload.id) {
            return {
              ...project,
              name: payload.name,
            }
          }

          return project
        }),
      }
    case ActionTypes.UPDATE_PROJECT_PREVIEW:
      return {
        ...state,
        projects: state.projects.map((project) => {
          if (project.id === payload.id) {
            return {
              ...project,
              thumbnail: payload.thumbnail,
              isLoading: payload.isLoading,
            }
          }

          return project
        }),
      }
    case ActionTypes.DELETE_PROJECT: {
      const { projects, projectsLimit, projectsCount } = state
      const { archived } = projects.find(({ id }) => id === payload)
      const nextCount = archived ? projectsCount : projectsCount - 1
      const nextLimit = archived ? projectsLimit : projectsLimit + 1

      return {
        ...state,
        projectsCount: nextCount,
        projectsLimit: nextLimit,
        projects: projects.filter(({ id }) => !(id === payload)),
      }
    }
    case ActionTypes.UPDATE_PROFILE:
      return {
        ...state,
        ...payload,
      }
    case ActionTypes.SETUP_SUCCESS:
      return {
        ...state,
        ...payload,
      }
    case ActionTypes.RESET_AUTH:
      window.localStorage.removeItem('token')

      return initialState
    case ActionTypes.LOGOUT_SUCCESS: {
      const keysToPreserve = ['cookies', LAST_WORKSPACE_KEY]

      const preservedData = keysToPreserve.reduce((acc, key) => {
        acc[key] = localStorage.getItem(key)
        return acc
      }, {})

      localStorage.clear()

      Object.entries(preservedData).forEach(([key, value]) => {
        if (value !== null) {
          localStorage.setItem(key, value)
        }
      })

      return initialState
    }
    case ActionTypes.SET_AUTH:
      return {
        ...state,
        ...payload,
        authenticated: true,
      }
    case ActionTypes.CONNECT_FIGMA:
      return {
        ...state,
        integrations: {
          figma: payload,
        },
      }
    case ActionTypes.DISCONNECT_FIGMA:
      return {
        ...state,
        integrations: {
          figma: false,
        },
      }

    case ActionTypes.SET_USER_EMOJIS:
      return {
        ...state,
        emojis: payload,
      }

    case ActionTypes.SAVE_PROJECT_SUCCESS:
      return {
        ...state,
        projects: [
          {
            id: payload.id,
            name: payload.name,
            archived: payload.archived,
            update_at: payload.updatedAt,
          },
          ...state.projects,
        ],
      }
    case ActionTypes.MESSAGE_VIEWED:
      return {
        ...state,
        messages: state.messages.filter((message) => message.id !== payload),
      }

    default:
      return state
  }
}

export const logout = () => ({
  type: ActionTypes.LOGOUT_SUCCESS,
})

// Old implementation is replaced by the new one in store/reducers/manager/meta

export const updateProjectCustomAvatar = (payload) => (dispatch) => {
  dispatch({ type: ActionTypes.UPDATE_PROJECT_CUSTOM_AVATAR, payload })
}

export const avatarDeleteRequest = (deleteAvatar) => (dispatch) => {
  dispatch(openSystemDialog(DELETE_AVATAR, { deleteAvatar }))
}

export const setMessageViewed = (payload) => ({
  type: ActionTypes.MESSAGE_VIEWED,
  payload,
})

export default auth
